export const componentEn = {
  usersTable: {
    search: 'Search in the list (name, department)',
    searchWithoutDepartment: 'Search in the list (name, position)',
    searchWithPosition: 'Search in the list (name, department, position)'
  },
  departmentEditor: {
    createDepartment: 'Create department',
    saveDepartment: 'Save department',
    deleteDepartment: 'Delete department',
    departmentMembers: 'Department participants',
    departmentManager: 'Head of department',
    departmentUser: 'Department participant',
    departmentRole: 'Department role',
    newDepartment: 'New department',
    editDepartment: 'Edit department',
    parentDepartment: 'Parent department',
    withoutParentDepartment: 'Without parent department'
  },
  dropdown: {
    selected: 'Selected',
    all: 'All',
    notSelected: 'Not selected',
    outOf: 'out of'
  },
  dateFilter: {
    set: 'Set',
    notSet: 'Not set',
    expired: 'Expired',
    notExpired: 'Not expired'
  },
  timerFilter: {
    set: 'Launched',
    notSet: 'Time is not set',
    pinned: 'Pinned',
    notPinned: 'Not pinned',
    expired: 'Expired',
    notExpired: 'Not expired',
    stopped: 'Stopped'
  },
  filters: {
    clone: 'Duplicate group',
    delete: 'Delete group',
    filterGroup: 'Filter group',
    filterGroupTasks: 'tasks satisfying the conditions',
    addFilterGroup: 'Add filter group',
    resultsCombined: 'Group results are combined',
    withoutName: 'Without name',
    found: 'Found'
  },
  textFilter: {
    text: 'Text',
    taskTitle: 'Task name',
    columnTitle: 'Column name',
    boardTitle: 'Board name',
    projectTitle: 'Project name',
    taskDescription: 'In description',
    checklists: 'In subtasks',
    filenames: 'In file name',
    messages: 'In chat',
    placeholder: 'Enter word of phrase'
  },
  subtasksFilters: {
    subtasks: 'Has subtasks',
    subtasksYes: 'With subtasks',
    subtasksNo: 'Without subtasks',
    deadline: 'Subtasks deadline',
    assigned: 'Subtasks assignees',
    completed: 'Subtasks completed',
    completedYes: 'All subtasks completed',
    completedNo: 'Not all subtasks completed'
  },
  chatFilter: {
    chat: 'Chat',
    more: 'More than',
    less: 'Less than',
    withoutMessages: 'Without messages',
    messageCount: 'Message count'
  },
  stickerFilter: {
    notSet: 'No value selected',
    notPinned: 'Not pinned'
  },
  stickerTextFilter: {
    allFilled: 'All filled',
    allEmpty: 'All empty'
  },
  stickerNumericFilter: {
    setRange: 'Set range'
  },
  tree: {
    showMore: 'Show more...',
    enterName: 'Enter task name for search'
  }
}

export const componentRu: typeof componentEn = {
  usersTable: {
    search: 'Поиск по списку (имя, отдел)',
    searchWithoutDepartment: 'Поиск по списку (имя, должность)',
    searchWithPosition: 'Поиск по списку (имя, отдел, должность)'
  },
  departmentEditor: {
    createDepartment: 'Создать отдел',
    saveDepartment: 'Сохранить отдел',
    deleteDepartment: 'Удалить отдел',
    newDepartment: 'Новый отдел',
    editDepartment: 'Редактирование отдела',
    departmentMembers: 'Сотрудник отдела',
    departmentManager: 'Руководитель отдела',
    departmentUser: 'Сотрудник отдела',
    departmentRole: 'Роль в отделе',
    parentDepartment: 'Родительский отдел',
    withoutParentDepartment: 'Без родительского отдела'
  },
  dropdown: {
    selected: 'Выбрано',
    notSelected: 'Не выбрано',
    all: 'Все',
    outOf: 'из'
  },
  dateFilter: {
    set: 'Установлен',
    notSet: 'Не установлен',
    expired: 'Истёк',
    notExpired: 'Не истёк'
  },
  timerFilter: {
    set: 'Запущен',
    notSet: 'Не установлено время',
    pinned: 'Прикреплён',
    notPinned: 'Не прикреплён',
    expired: 'Просрочен',
    notExpired: 'Не просрочен',
    stopped: 'Остановлен'
  },
  filters: {
    clone: 'Дублировать группу',
    delete: 'Удалить группу',
    filterGroup: 'Группа фильтров',
    filterGroupTasks: 'задач, удовлетворяющих условиям',
    addFilterGroup: 'Добавить группу фильтров',
    resultsCombined: 'Результаты групп объединяются',
    withoutName: 'Без названия',
    found: 'Найдено'
  },
  textFilter: {
    text: 'Текст',
    taskTitle: 'Название задачи',
    columnTitle: 'Название колонки',
    boardTitle: 'Названия доски',
    projectTitle: 'Название проекта',
    taskDescription: 'В описании',
    checklists: 'В подзадачах',
    filenames: 'В названии файла',
    messages: 'В чате',
    placeholder: 'Введите слово или фразу'
  },
  subtasksFilters: {
    subtasks: 'Наличие подзадач',
    subtasksYes: 'С подзадачами',
    subtasksNo: 'Без подзадач',
    deadline: 'Дедлайн подзадач',
    assigned: 'Исполнители подзадач',
    completed: 'Статус выполнения подзадач',
    completedYes: 'Все подзадачи выполнены',
    completedNo: 'Не все подзадачи выполнены'
  },
  chatFilter: {
    chat: 'Чат',
    more: 'Сообщений больше чем',
    less: 'Сообщений меньше чем',
    withoutMessages: 'Без общения',
    messageCount: 'Кол-во сообщений'
  },
  stickerFilter: {
    notSet: 'Не выбрано значение',
    notPinned: 'Не прикреплён'
  },
  stickerTextFilter: {
    allFilled: 'Все заполненные',
    allEmpty: 'Все пустые'
  },
  stickerNumericFilter: {
    setRange: 'Указать диапазон'
  },
  tree: {
    showMore: 'Показать ещё...',
    enterName: 'Введите название задачи для поиска'
  }
}
